import axios from 'axios';

const updateFeeByID = async (
    fee: ({ day: number; _id: string; value: number } | undefined)[],
    feeType: string,
    setLoading: (value: boolean) => void,
    setAction: any
) => {
    setLoading(true);
    try {
        await axios.patch(`/api/fees?type=${feeType}&updateType=id`, {
            ...fee,
        });
    } catch (error) {
        console.log(error);
    } finally {
        setLoading(false);
        setAction({ status: false, type: feeType });
    }
};

export default updateFeeByID;
